import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader';
import { list, updateCompanyData } from '../api/company';
export default function CompanyDefaultSetting() {
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [dynamicFormData, setDynamicFormData] = useState([])
    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState("0");
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);

    const handleChange = async (e) => {
        const { value, } = e.target;
        console.log("company name", value);
        const filterCompanyData = option.find(item => item.id === value);

        const blankObj = Object.keys(formData).reduce((acc, key) => {
            acc[key] = "";
            return acc;
        }, {});
        setFormData(blankObj);

        if (filterCompanyData?.defaultSettings) {
            let defValue = filterCompanyData?.defaultSettings
            const updatedObj = Object.fromEntries(
                Object.entries(formData).map(([key, value]) => [
                    key,
                    defValue.hasOwnProperty(key) ? defValue[key] : value
                ])
            );
            setFormData(updatedObj);
        }
        setCompanyName(value);
    }

    const getCompanyList = async () => {
        setLoading(true);
        let data = await list();
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            }))
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/json/company_default_settings.json`)
            .then((response) => response.json())
            .then((data) => {
                setDynamicFormData(data)

                const formObject = data.reduce((acc, item) => {
                    acc[item.field] = "";
                    return acc;
                }, {});

                setFormData(formObject)

            })
            .catch((error) => console.error("Error loading JSON:", error));
    }, []);


    const validate = () => {
        let tempErrors = {};
        dynamicFormData.forEach(item => {
            const value = formData[item.field];
            if (item.required && (!value || value.trim() === "")) {
                tempErrors[item.field] = `${item.errorMessage} `;
            }
        });
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleValueChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => ({
            ...prev,
            [field]: ""
        }));
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        if (companyName === "0") {
            setErrorStatus('danger')
            setApiError("Please select company...")
            return
        }
        if (validate()) {
            setLoading(true);
            let passData = {
                "_id": companyName,
                "defaultSettings": formData
            }
            const updateDataResult = await updateCompanyData(passData);
            setLoading(false);

            if (updateDataResult.status > 199 && updateDataResult.status <= 399) {
                setErrorStatus('success')
                setApiError(updateDataResult.data.message)

                const updatedArray = option.map(item =>
                    item._id === companyName ? { ...item, defaultSettings: formData } : item
                );
                setOption(updatedArray);
            } else {
                setErrorStatus('danger')
                setApiError(updateDataResult.data.message)
            }
        } else {
            setApiError("Please add required fields")
            setErrorStatus('danger')
        }
    };
    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    return (
        <>
            {loading && <Loader />}
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} >
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <div className="row">

                    <div className="page-header">
                        <h3 className="page-title"> Set Default Setting </h3>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="button" onClick={handleSubmit} className="btn btn-primary me-2">Save</button>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-12 grid-margin">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    {companyName != "0" && dynamicFormData.map((item, index) => (
                                        <div className="col-md-4" key={index}>
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername1">{item.label}</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    placeholder={item.label}
                                                    value={formData[item.field] || ""}
                                                    onChange={(e) => handleValueChange(item.field, e.target.value)}
                                                />
                                                {errors[item.field] && <span className="text-danger">{errors[item.field]}</span>}
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
